/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StudentMessage } from '../../models/student-message';
import { StudentMessageId } from '../../models/student-message-id';

export interface ApiTicketTicketIdMessagePost$Params {
  ticket_id: number;
      body: StudentMessage
}

export function apiTicketTicketIdMessagePost(http: HttpClient, rootUrl: string, params: ApiTicketTicketIdMessagePost$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentMessageId>> {
  const rb = new RequestBuilder(rootUrl, apiTicketTicketIdMessagePost.PATH, 'post');
  if (params) {
    rb.path('ticket_id', params.ticket_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StudentMessageId>;
    })
  );
}

apiTicketTicketIdMessagePost.PATH = '/api/ticket/{ticket_id}/message';
